import { createSelector } from 'reselect';
import { SCOPE } from './types';

const selector = state => state[SCOPE];

// looks like some of these selectors are broken
// since the redux store strucutre has changed
// TODO: cleanup

export const persistenceLoadingSelector = createSelector(
  selector, state => state.loading,
);

export const skipPersistenceSelector = createSelector(
  selector, state => state.skipGetAction,
);

export const listFetchedSelector = createSelector(
  selector, state => state.isFetched,
);

export const responseSelector = createSelector(
  selector, state => state.response,
);


export const persistenceResponseSelector = createSelector(
  selector, state => state.persistenceData,
);

export const persistenceKeySelector = createSelector(
  selector, state => state.activePersistenceKey,
);

export default selector;
